/* eslint-disable eqeqeq */
import { register } from "swiper/element/bundle";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import api from "../../Services/api";
import { useState, useEffect } from "react";
import ReactLoading from "react-loading";

register();

const ContainerMedicosLP = ({ busca }) => {
	const [slidePerView, setSlidePerView] = useState(3);
	useEffect(() => {
		function handleResize() {
			if (window.innerWidth < 768) {
				setSlidePerView(1);
			} else {
				setSlidePerView(3);
			}
		}
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const [dados, setDados] = useState([]);
	const [infoPagina, setInfoPagina] = useState(
			{
			has_next: false,
			has_previous: false,
			per_page: 20,
			page: 1,
			total: 0,
			}
		);
	const [loading, setLoading] = useState(false);

	const getData = async () => {
		if (busca == null || busca == "") {
			setDados([]);
			return null;
		}
		setLoading(true);
		try {
			const response = await api.get(`/medicos/pesquisa?pesquisa=${busca}&page=${infoPagina.page}&per_page=5`).catch((error) => {console.log(error)});
			console.log(response.data, "data");
			setDados(response.data.medicos);
			setInfoPagina(
				{
					...infoPagina,
					has_next: response.data.has_next,
					has_previous: response.data.has_previous,
					total: response.data.total,
				}
			);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [busca, infoPagina.page]);

	return (
		<div className="bg-brancoID py-20">
			{dados.length > 0 && (
				<>
					<div className="flex flex-row mx-auto justify-center items-center space-x-2">
						<h1 className="text-verdeEscuro text-4xl font-bold flex justify-center mb-5">Médicos</h1>
						{loading && (
							<ReactLoading
								type="spin"
								color="#067187"
								height={"20px"}
								width={"20px"}
								className="mb-4"
							/>
						)}
					</div>
					<Swiper
						slidesPerView={slidePerView}
						pagination={{ clickable: true }}
						navigation
						className=" w-[74%] px-10 pb-20">
							
						{dados.map((item) => (
							<SwiperSlide className="m-2 flex flex-col items-center">
								<p className="flex text-xl">{item.usuario.NO_primeiro_nome + " " + item.usuario.NO_ultimo_nome}</p>
								<p className="flex text-center">
									{item.usuario.cidade.NO_cidade}, {item.usuario.estado.NO_estado}
								</p>
								<p className="flex">
									Especialidades:&nbsp;
									{item.especialidades.map((item, key) => {
										if (key == 0) {
											return <p className="flex">{item.NO_especialidade}</p>;
										} else {
											return <p className="flex">,&nbsp;{item.NO_especialidade}</p>;
										}
									})}
								</p>
							</SwiperSlide>
						))}
					</Swiper>
				</>
			)}
		</div>
	);
};

export default ContainerMedicosLP;
